// TODO: EB-189969 - add final merchant ID
export const GOOGLE_PAY_MERCHANT_ID = 'my-merchant-id-from-google';
